import React from "react";
import { Avatar as AntdAvatar } from "antd";
import type { AvatarProps as AntdAvatarProps } from "antd";

export type AvatarProps = AntdAvatarProps
export const Avatar = AntdAvatar;
